import api from "../api";

export class CartService {
	constructor(params = {}) {
		this.count = 0;

		/* Принимает функцию для отображения */
		this.counterTemplate = params.counterTemplate || false;

		this.$cartCount = $(".js-count");
	}

	getCount() {
		return api.cart.count().then(res => {
			if (!res) return this.$cartCount.text(0).hide();
			this.count = res.count;
			return this.updateCount();
		});
	}

	updateCount() {
		if (!this.count) return this.$cartCount.hide();

		return this.$cartCount.html(this.renderCountText()).show();
	}

	renderCountText() {
		if (!this.counterTemplate) return this.count;
		return this.counterTemplate(this.count);
	}
}

export const cartService = new CartService();
